export const firebaseConfig = {
  apiKey: "AIzaSyCcBx7yeY6zldeiVeHICrXK9BNUafrfFGs",
  authDomain: "city-ride1.firebaseapp.com",
  projectId: "city-ride1",
  storageBucket: "city-ride1.appspot.com",
  messagingSenderId: "309634236504",
  appId: "1:309634236504:web:158014e0ac777b05bb4a2d",
};
